
<div class="row">
    <div class="col-12 team-special-margin">
    <div class="card">
        <div class="card-body" style="padding: 50px;">
            <div class="row" style="margin-top: 20px;margin-bottom: 20px;">
                <div class="col-lg-6">
                    Consultas
                </div>
                <div class="col-lg-6 d-flex justify-content-end" >
                    <input class="form-control me-sm-2" type="text"  (keyup.enter)="buscar()" [(ngModel)]="palabraClave" style="width: 300px;" placeholder="Buscar">
                    <button class="btn btn-secondary" type="submit" (click)="buscar()" style="width: 130px;"><i class="fas fa-search"></i> Buscar</button>
                </div>
            </div>
            
            <div class="row" [className]="consulta.respuesta===null? 'row cons-pendiente' : 'row cons-completa'" *ngFor="let consulta of consultas | paginate: { id: 'listing_pagination',
                                                    itemsPerPage: 10,
                                                    currentPage: page,
                                                    totalItems: totalRec }" style="margin-bottom: 5px;background: #EAEEFB 0% 0% no-repeat padding-box; padding: 10px;border-radius: 10px;">
               
                <div class="col-sm-2" >
                    <p>{{consulta.fechaIngreso | date:'dd-MM-yyyy HH:mm':'-0' }}</p>
                </div>                                                                        
                <div class="col-sm-8" >
                    <p>{{consulta.consulta}}</p>
                </div>
                <div class="col-sm-2" >
                    <button type="button" *ngIf="consulta.respuesta!=null" (click)="responder(consulta)" class="btn btn-light btn-send" style="background: #597CEE 0% 0% no-repeat padding-box;border-radius: 10px; height: 38px;opacity: 1; color: #FFFFFF;"   > Revisar</button>
                    <button type="button" *ngIf="consulta.respuesta===null" (click)="responder(consulta)" class="btn btn-light btn-send" style="background: #597CEE 0% 0% no-repeat padding-box;border-radius: 10px; height: 38px;opacity: 1; color: #FFFFFF;"   > Responder</button>
                </div>
            </div>
            
            <pagination-controls  id="listing_pagination" maxSize="5" directionLinks="true" (pageChange)="getServerData($event)"></pagination-controls>
        </div>

        </div>
    </div>
</div>


<ng-template #modalContent let-close="close">
    <div class="modal-header">
      <h5 class="titulo-card-rojo" style="margin-left: 14px;">Responder Consulta</h5>
      <button type="button" class="close" (click)="close()" style="background: none;
      border: none;
      font-size: xx-large;">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" style="padding: 30px;">
        <div class="row">
            <div class="col-sm-12">
                <p>Fecha de Ingreso :  {{modalData?.consulta?.fechaIngreso | date:'dd/MM/yyyy HH:mm'}}</p>
            </div>
       </div>
       <div class="row">
            <div class="col-sm-6">
                <p>Jardin : {{modalData?.jardin?.jardin}}</p>
            </div>
            <div class="col-sm-6">
                <p>RBD : {{modalData?.jardin?.rbd}}</p>
            </div>
       </div>

       <div class="row mt-3" >
        <div class="col-sm-12">
            <p class="table-row-title"> Respuesta</p>
            <textarea class="text-area-comentario" name="respuesta" [(ngModel)]="modalData.consulta.respuesta" #respuesta='ngModel' style="background: #F5F6FC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;border: none;margin-bottom: 10px;width: 100%; height: 165px;padding: 10px;"></textarea>
        </div> 
             
    </div>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary"  (click)="enviarRespuesta(modalData)" style="    background-color: #597CEE;
        color: #FFFFFF;
        padding: 10px;
        margin-top: 10px;
        padding-left: 15px;
        padding-right: 15px;
        margin-right: 15px;
        margin-bottom: 10px;">
            Responder
        </button> 
        <button type="button" class="btn btn-outline-secondary" (click)="close()" style="    background-color: #3E445E;
        color: #FFFFFF;
        padding: 10px;
        margin-top: 10px;
        padding-left: 15px;
        padding-right: 15px;
        margin-right: 15px;
        margin-bottom: 10px;">
            Cerrar
        </button> 
    </div>
  </ng-template> 


<ngx-spinner></ngx-spinner>